module.exports = __webpack_public_path__ + "static/media/elo.7fc2aba7.svg";